module.exports = __webpack_public_path__ + "static/media/icon_tree_branches_grass_and_leaves.ad2882af.svg";